/**
 * wa-scheduler#129 — Authorization header resolution for the API baseQuery.
 *
 * Extracted from prepareHeaders so the fallback ordering is unit-testable.
 * Redux auth state is the primary source; when it hasn't hydrated (e.g. a
 * gateway engine whose boot-time POST /authentication raced a backend rollout) we fall
 * back to the persisted token from the authoritative hub the gateway seeds.
 * Without the fallback every request goes out with NO auth header and 401s
 * silently — dropping ~40% of inbound wa-message-listener-event POSTs
 * fleet-wide, with no self-heal until a lucky reboot.
 */
export async function applyAuthHeader(
    headers: Headers,
    reduxAccessToken: string | undefined | null,
    getPersistedToken: () => Promise<string | null>,
): Promise<void> {
    if (reduxAccessToken) {
        headers.set('Authorization', `Bearer ${reduxAccessToken}`);
        return;
    }
    try {
        const persisted = await getPersistedToken();
        if (persisted) headers.set('Authorization', `Bearer ${persisted}`);
    } catch {
        // best-effort: leave the header unset rather than throw out of prepareHeaders
    }
}
